export default __webpack_public_path__ + "static/media/gallery (10).cf15bc8c.png";